import logo from './brand/logo-cubas.webp';
import { cn } from '@/shared/utils/cn';

/**
 * The logo of the shop: the hand, the name and «suministros industriales» under it, in the
 * red that the rest of the palette is derived from (`--color-brand`, see `index.css`).
 *
 * One file, two surfaces. On paper it goes as it is. On the dark sidebar it goes in white,
 * with a CSS filter instead of a second file: the logo is a single flat colour on a
 * transparent background, so `brightness(0) invert(1)` gives the exact white version and
 * there is nothing that can drift between the two.
 *
 * The caller sets the height (`h-10`, `h-16`…) and nothing else; the width follows the file.
 * No default height: `cn` does not merge Tailwind classes, and two `h-*` on one element would
 * leave the winner to the order of the generated stylesheet.
 *
 * One trap: as a direct child of a column flexbox (`flex-col`) the image is a flex item and
 * `align-items: stretch` widens it to the whole column while the height stays fixed, so the
 * logo comes out squashed. There the caller adds `self-start` (see the login page).
 */
export function Logo({
  className,
  inverted = false,
}: {
  className?: string;
  /** White, for the sidebar and the dark half of the login page. */
  inverted?: boolean;
}) {
  return (
    <img
      src={logo}
      alt="Cubas, suministros industriales"
      draggable={false}
      className={cn('w-auto select-none', inverted && 'brightness-0 invert', className)}
    />
  );
}
